// src/services/email.js
import emailjs from "@emailjs/browser";

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

const eur = (n) => `${Number(n || 0).toFixed(2)} EUR`;

/**
 * Notifies the admin that an order came in.
 *
 * Deliberately never throws: the order is already committed to Firestore
 * by the time this runs, so a failed email must not make the customer
 * think their order failed. It logs and resolves false instead.
 */
export const sendOrderEmail = async ({
  orderId,
  customer,
  items,
  total,
  shipping = 0,
  countryLabel = "",
  note,
}) => {
  if (!SERVICE_ID || !TEMPLATE_ID || !PUBLIC_KEY) {
    console.warn("EmailJS not configured — skipping order notification.");
    return false;
  }

  const lines = items
    .map(
      (l) => `${l.qty} x ${l.nameSq} (${l.pmuCode}) — ${eur(l.price * l.qty)}`,
    )
    .concat(
      shipping > 0 ? [`Transporti — ${eur(shipping)}`] : ["Transporti — falas"],
    )
    .join("\n");

  try {
    await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      {
        order_id: orderId,
        customer_name: customer.name,
        customer_phone: customer.phone,
        customer_email: customer.email || "—",
        customer_city: countryLabel
          ? `${customer.city}, ${countryLabel}`
          : customer.city,
        customer_address: customer.address,
        order_items: lines,
        order_total: eur(total),
        order_note: note || "—",
        order_date: new Date().toLocaleString("sq-AL"),
      },
      { publicKey: PUBLIC_KEY },
    );
    return true;
  } catch (err) {
    console.error("Order email failed", err);
    return false;
  }
};

/**
 * Notifies the admin of a sample request. Same rule as orders: never throws,
 * because the request is already in Firestore before this runs.
 */
export const sendSampleRequestEmail = async ({
  requestId,
  productName,
  pmuCode,
  contact,
  note,
}) => {
  if (!SERVICE_ID || !TEMPLATE_ID || !PUBLIC_KEY) {
    console.warn(
      "EmailJS not configured - skipping sample request notification.",
    );
    return false;
  }

  try {
    await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      {
        order_id: `MOSTER-${requestId.slice(0, 8).toUpperCase()}`,
        customer_name: `${contact.contactName} (${contact.businessName})`,
        customer_phone: contact.phone,
        customer_email: contact.email,
        customer_city: contact.city || "-",
        customer_address: `Instagram: @${contact.instagram}`,
        order_items: `KERKESE PER MOSTER: ${productName}${pmuCode ? ` (${pmuCode})` : ""}`,
        order_total: "Mostre - pa pagese",
        order_note: note || "-",
        order_date: new Date().toLocaleString("sq-AL"),
      },
      { publicKey: PUBLIC_KEY },
    );
    return true;
  } catch (err) {
    console.error("Sample request email failed", err);
    return false;
  }
};
